import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { requestOtherClientAppointments } from "./workflowSlice";

/**
 * For screens that read ARCHIVED or HISTORY workflows. Mounting one starts the
 * listener over every non-WORKFLOW status (App.tsx), which then keeps running
 * until sign out. Returns whether that data has arrived, so the screen can
 * show it is loading instead of an empty list.
 */
const useOtherClientAppointments = () => {
  const dispatch = useDispatch();
  const isRequested = useSelector((state) => state.workflow.isOtherClientAppointmentsRequested);
  const isLoaded = useSelector((state) => state.workflow.isOtherClientAppointmentsLoaded);

  useEffect(() => {
    if (!isRequested) {
      dispatch(requestOtherClientAppointments());
    }
  }, [dispatch, isRequested]);

  return isLoaded;
};

export default useOtherClientAppointments;
